import { render } from "./TableRow.vue?vue&type=template&id=08603e3c"
import script from "./TableRow.vue?vue&type=script&lang=js"
export * from "./TableRow.vue?vue&type=script&lang=js"
script.render = render

export default script